import React, { useState, useEffect, useCallback } from 'react'
import { Table, toaster, Button, Pane, FormField, TextInput, Combobox } from 'evergreen-ui'
import { Heading, Link } from 'evergreen-ui/commonjs/typography';
import { connect } from 'react-redux'
import axios from '../../../../../Utils/axios';
import { unsetLoading, setLoading } from '../../../../../Redux/reducers/loading'
import LocationDialog from '../LocationDialog'
import * as moment from 'moment'
import 'moment/locale/pt-br';
const Attendances = ({
  dispatch
}) => {
  const [attendances, setAttendances] = useState([])
  const [dates, setDates] = useState({
    dateFrom: '',
    dateTo: ''
  })
  const [ employees, setEmployees ] = useState([])
  const [ employee, setEmployee ] = useState(null)
  const [ columns, setColumns ] = useState(0)
  const [dialogIsVisible, setDialogVisibility] = useState(false)
  const [attendanceLocation, setAttendanceLocation] = useState(null)
  const [attendanceDateTime, setAttendanceDateTime] = useState(null)

  const getAttendances = useCallback(async (fromDate, toDate, employeeFilter) => {
    try {
      const { data } = await axios.get(`/company/timeclock/attendances/employees/${employeeFilter}?fromDate=${fromDate}&toDate=${toDate}`)

      if (data.attendances.length === 0) {
        toaster.danger('Funcionário sem ocorrências no período informado', {
          duration: 3
        })
      }

      let dateGroup = {}
      let numCols = 0;
      data.attendances.forEach(entry => {
        const [ date, time ] = entry.time.split(' ')
        dateGroup[date] = (dateGroup[date] || []).concat([{
          id: entry.__id__,
          time,
          location: { latitude: entry.latitude, longitude: entry.longitude }
        }])

        dateGroup[date].sort((a, b) => {
          if (a.time < b.time) return -1
          if (a.time < b.time) return 1
          return 0
        })

        if (numCols < dateGroup[date].length) {
          numCols = dateGroup[date].length
        }
      });
      setColumns(numCols);
      const listAttendance = Object.keys(dateGroup).map(date => {
        return {
          date,
          hours : dateGroup[date]
        }
      })
      setAttendances(listAttendance)
    }
    catch (error) {
      toaster.danger('Erro ao buscar as ocorrências')
    }
  }, [])

  const setDataAttendances = ({ target }) => {
    if (target.name === 'dateFrom' && moment(target.value).diff(dates.dateTo) > 0) {
      return toaster.danger('Data de início não pode ser superior a data de término', {
        duration: 3
      })
    }

    setDates({
      ...dates,
      [target.name]: target.value
    })
  }

  const searchSummary = (type = 0) => {
    const { dateFrom, dateTo } = dates;
    if (!dateFrom || !dateTo) {
      return toaster.danger('Período obrigatório!', {
        duration: 3
      })
    }
    if (!employee) {
      return toaster.danger('Informe um funcionário!', {
        duration: 3
      })
    }
    if (dateTo < dateFrom) {
      return toaster.danger('Data término menor que a data início!', {
        duration: 3
      })
    }
    if (type === 1){
      return sendEmail(dateFrom, dateTo, employee)
    }
    getAttendances(dateFrom, dateTo, employee);
  }

  const getEmployees = useCallback(async () => {

    dispatch(setLoading())
    try {
      const { data } = await axios.get(`/company/employees`);
      setEmployees(data.employees);
    }
    catch (error) {
      toaster.danger('Falha ao buscar dados');
    }
    finally {
      dispatch(unsetLoading());
    }
  }, [dispatch] )

    function handleSetEmployee(employeeFilter) {
        employeeFilter = employeeFilter.toString();

        if (!employeeFilter){
            return toaster.danger('Funcionário é obrigatório!');
        }
        if (!employees.filter(employee => employee.name === employeeFilter)) {
            return toaster.danger('Funcionário é inválido!')
        }
        setEmployee(employees.find(item => item.name === employeeFilter).__id__);
    }

    function handleNameOfDay(day) {
      moment.locale('pt-BR');
      return moment(day).format('dddd')
    }

    function handleEditDate(date) {
      return moment(date).format('DD/MM/YYYY')
    }

    function handleEditTime(time) {
      const [ hour, minutes ] = time.split(':',2)
      return hour + ":" + minutes
    }

    function handleColumn(columnSize){
      if (columnSize < columns) {
        const value = columns - columnSize
          const arrayEmpty = new Array(value)
          var collumns = arrayEmpty.fill(true);

          return (collumns.map((i, index) => {
            return <Table.TextCell key={index} />
          }))
      }
      return
    }

    function selectAttendanceLocation (attendance, date) {
      setDialogVisibility(true)
      setAttendanceLocation(attendance.location)
      setAttendanceDateTime({ date: `${handleEditDate(date)} ${attendance.time}`})
    }

    const sendEmail = async (fromDate, toDate, employeeFilter) => {
      dispatch(setLoading())
      try {
        const { status } = await axios.post(`/company/timeclock/attendances/employees/${employeeFilter}/email?fromDate=${fromDate}&toDate=${toDate}`)
        if (status === 200) {
          toaster.success('E-mail enviado com sucesso!')
        }
      }
      catch (error) {
        dispatch(unsetLoading());
        toaster.danger('Erro ao enviar e-mail!')
      }
      dispatch(unsetLoading());
    }

    useEffect(() => {
        getEmployees();
    },[getEmployees]);

  return (
    <React.Fragment>
      <Heading size={600}> Consulta Ocorrência de Ponto </Heading>
      <div style={{ marginLeft: 10, marginRight: 10, marginTop: 0, display: 'block' }}>
        <Pane display="flex" padding={16} borderRadius={3}>
          <Pane flex={1} alignItems="center" display="flex">
          <FormField
              label='Funcionário'
            >
            <Combobox
                items={employees.filter(employee => employee.usesTimeClock === true && employee.active === true).map(employee => employee.name)}
                onChange={selected => handleSetEmployee(selected)}
                placeholder="Funcionário"
            />
            </FormField>
          </Pane>
          <Pane flex={1} alignItems="center" display="flex">
            <FormField
              label='Data Início'
            >
              <TextInput
                type='date'
                placeholder='Data inicio'
                name='dateFrom'
                width={140}
                value={dates.dateFrom}
                onChange={setDataAttendances}
              />
            </FormField>
          </Pane>
          <Pane flex={1} alignItems="center" display="flex">
            <FormField
              label='Data Término'
            >
              <TextInput
                type='date'
                placeholder='Data fim'
                name='dateTo'
                width={140}
                value={dates.dateTo}
                onChange={setDataAttendances}
              />
            </FormField>
          </Pane>
          <Pane flex={2} alignItems="center" display="flex">
            <Button marginLeft={16} marginTop={20} iconBefore="search"
              onClick={() => searchSummary()} > Consultar </Button>
              <Button marginLeft={16} marginTop={20}  iconBefore="mail" appearance="primary" onClick={() => searchSummary(1)}>Enviar E-mail</Button>
          </Pane>
        </Pane>
      </div>
      <Table style={{ marginTop: 15 }} >
        <Table.Head>
          <Table.TextHeaderCell>
            Data
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Dia
          </Table.TextHeaderCell>
          <Table.TextHeaderCell flex={columns}>
            Batidas
          </Table.TextHeaderCell>
        </Table.Head>
        <Table.Body>
           {
           attendances.map(attendance => (
            <Table.Row key={attendance.date} flex={1}>
              <Table.TextCell >{handleEditDate(attendance.date)}</Table.TextCell>
              <Table.TextCell >{handleNameOfDay(attendance.date)}</Table.TextCell>
              {
                attendance.hours.map(hour => (
                  <Table.TextCell key={hour.id}>
                    <Link href="#" onClick={() => selectAttendanceLocation(hour, attendance.date)}>{handleEditTime(hour.time)}</Link>
                  </Table.TextCell>
                )
              )
            }
            {
              handleColumn(attendance.hours.length)
            }
            </Table.Row>
          ))}
        </Table.Body>
      </Table >
      { dialogIsVisible && <LocationDialog visible={dialogIsVisible} close={() => setDialogVisibility(false)} location={attendanceLocation} dateTime={attendanceDateTime} />}
    </React.Fragment>
  )
}

const mapStateToProps = ({ auth, loading }) => ({
  company: auth.account,
})
export default connect(mapStateToProps)(Attendances)
